import { Constants } from "../Engines/constants";
/**
 * Class used to represent data loading progression
 */

var SceneLoaderFlags =
/** @class */
function () {
  function SceneLoaderFlags() {}

  Object.defineProperty(SceneLoaderFlags, "ForceFullSceneLoadingForIncremental", {
    /**
     * Gets or sets a boolean indicating if entire scene must be loaded even if scene contains incremental data
     */
    get: function get() {
      return SceneLoaderFlags._ForceFullSceneLoadingForIncremental;
    },
    set: function set(value) {
      SceneLoaderFlags._ForceFullSceneLoadingForIncremental = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SceneLoaderFlags, "ShowLoadingScreen", {
    /**
     * Gets or sets a boolean indicating if loading screen must be displayed while loading a scene
     */
    get: function get() {
      return SceneLoaderFlags._ShowLoadingScreen;
    },
    set: function set(value) {
      SceneLoaderFlags._ShowLoadingScreen = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SceneLoaderFlags, "loggingLevel", {
    /**
     * Defines the current logging level (while loading the scene)
     * @ignorenaming
     */
    get: function get() {
      return SceneLoaderFlags._loggingLevel;
    },
    set: function set(value) {
      SceneLoaderFlags._loggingLevel = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SceneLoaderFlags, "CleanBoneMatrixWeights", {
    /**
     * Gets or set a boolean indicating if matrix weights must be cleaned upon loading
     */
    get: function get() {
      return SceneLoaderFlags._CleanBoneMatrixWeights;
    },
    set: function set(value) {
      SceneLoaderFlags._CleanBoneMatrixWeights = value;
    },
    enumerable: true,
    configurable: true
  }); // Flags

  SceneLoaderFlags._ForceFullSceneLoadingForIncremental = false;
  SceneLoaderFlags._ShowLoadingScreen = true;
  SceneLoaderFlags._CleanBoneMatrixWeights = false;
  SceneLoaderFlags._loggingLevel = Constants.SCENELOADER_NO_LOGGING;
  return SceneLoaderFlags;
}();

export { SceneLoaderFlags };